
import { Section2 } from "./Section2";
import { Section3 } from "./Section3";
import { Section9 } from "./Section9";
 import { Section4 } from "./Section4";
 import { Section5 } from "./Section5";
 import { Section7 } from "./Section7";
 import { Section8 } from "./Section8";
import { Section10 } from "./Section10";
import { Section6 } from "./Section6";
import { Section41 } from "./section41";
import { Section1 } from "./Section1";

export function How() {
    return <>
    <Section1/>
    <Section2/>
     <Section3/>
    <Section4 />
    <Section41/>
    <Section5 />
    <Section6/>
    <Section7 />
    <Section8 />
    <Section9/>
        <Section10 />
        </>
}